import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { SignOut, UserCircle, Phone } from "@phosphor-icons/react";

export const AppHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-zinc-950/60 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link
          to={user?.role === "admin" ? "/admin" : "/dashboard"}
          className="flex items-center gap-2"
          data-testid="header-logo"
        >
          <span className="font-display text-xl tracking-tighter text-foreground">
            DAFARGOS
          </span>
          <span className="overline text-primary mt-1">Holdings</span>
        </Link>
        <div className="flex items-center gap-4">
          <Link
            to="/tradelines"
            data-testid="header-tradelines-link"
            className="hidden sm:block text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Tradelines
          </Link>
          <Link
            to="/contact"
            data-testid="header-contact-link"
            className="hidden sm:block text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Contact
          </Link>
          <a
            href="tel:+18773274605"
            className="hidden lg:flex items-center gap-1.5 text-sm text-primary"
          >
            <Phone size={15} weight="fill" /> 1-877-327-4605
          </a>
          <span className="hidden sm:flex items-center gap-2 text-sm text-muted-foreground">
            <UserCircle size={18} weight="duotone" className="text-primary" />
            {user?.name}
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={doLogout}
            data-testid="logout-button"
            className="text-muted-foreground hover:text-foreground"
          >
            <SignOut size={18} className="mr-1" /> Sign out
          </Button>
        </div>
      </div>
    </header>
  );
};
